// constants for role names
export const ADMIN: string = 'admin';
export const LEADER: string = 'leader';
export const MEMBER: string = 'member';
export const USER: string = 'user';
